// extracted by mini-css-extract-plugin
export default {"products":"QA-z","card":"RA-z","oosMessaging":"SA-z"};